var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-list py-5 py-lg-6"},[_c('section',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('order-table')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }